export default "__VITE_ASSET__B6xxA9EL__"